"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSidebarBody = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var Sidebar_1 = require("../Sidebar");
exports.StyledSidebarBody = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  overflow-y: hidden !important;\n  top: 0;\n  width: 100%;\n  scrollbar-color: ", ";\n  scrollbar-width: thin;\n\n  &:hover {\n    overflow-y: auto !important;\n    overflow-y: overlay !important;\n  }\n\n  &::-webkit-scrollbar {\n    background: ", ";\n\n    &:hover {\n      &::-webkit-scrollbar-thumb {\n        background: ", ";\n      }\n    }\n  }\n\n  &::-webkit-scrollbar-track {\n    &:hover {\n      &::-webkit-scrollbar-thumb {\n        background: ", ";\n      }\n    }\n  }\n\n  &::-webkit-scrollbar-thumb {\n      background: ", ";\n    \n      &:hover {\n        background: ", ";\n      }\n    }\n  }\n    \n    &:hover {\n      scrollbar-color: ", ";\n      scrollbar-width: thin;\n    \n      &::-webkit-scrollbar-thumb {\n        background: ", ";\n      }\n    }\n\n  &:focus {\n    outline: none;\n  }\n"], ["\n  overflow-y: hidden !important;\n  top: 0;\n  width: 100%;\n  scrollbar-color: ",
    ";\n  scrollbar-width: thin;\n\n  &:hover {\n    overflow-y: auto !important;\n    overflow-y: overlay !important;\n  }\n\n  &::-webkit-scrollbar {\n    background: ", ";\n\n    &:hover {\n      &::-webkit-scrollbar-thumb {\n        background: ", ";\n      }\n    }\n  }\n\n  &::-webkit-scrollbar-track {\n    &:hover {\n      &::-webkit-scrollbar-thumb {\n        background: ", ";\n      }\n    }\n  }\n\n  &::-webkit-scrollbar-thumb {\n      background: ", ";\n    \n      &:hover {\n        background: ", ";\n      }\n    }\n  }\n    \n    &:hover {\n      scrollbar-color: ",
    ";\n      scrollbar-width: thin;\n    \n      &::-webkit-scrollbar-thumb {\n        background: ", ";\n      }\n    }\n\n  &:focus {\n    outline: none;\n  }\n"])), function (props) {
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", " ", "\n    "], ["\n      ", " ", "\n    "])), style_utils_1.getSidebarColor(25)(props), style_utils_1.getSidebarColor(0)(props));
}, style_utils_1.getSidebarColor(0), style_utils_1.getSidebarColor(100), style_utils_1.getSidebarColor(100), style_utils_1.getSidebarColor(25), style_utils_1.getSidebarColor(100), function (props) {
    return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          ", " ", "\n        "], ["\n          ", " ", "\n        "])), style_utils_1.getSidebarColor(100)(props), style_utils_1.getSidebarColor(0)(props));
}, style_utils_1.getSidebarColor(100));
var SidebarBody = function (_a) {
    var className = _a.className, children = _a.children, props = __rest(_a, ["className", "children"]);
    var expanded = react_1.default.useContext(Sidebar_1.SidebarContext).expanded;
    var bodyRef = react_1.default.useRef();
    var arrayChildren = react_1.default.useRef([]);
    var _b = __read(react_1.default.useState([]), 2), isOpen = _b[0], setIsOpen = _b[1];
    var numberOfDividers = react_1.default.useMemo(function () {
        var _a;
        var num = 0;
        (_a = arrayChildren === null || arrayChildren === void 0 ? void 0 : arrayChildren.current) === null || _a === void 0 ? void 0 : _a.forEach(function (child) {
            if (child.classList.contains("sidebar--divider")) {
                num++;
            }
        });
        return num;
    }, [arrayChildren.current]);
    react_1.default.useEffect(function () {
        if (react_1.default.Children.count(children) !== arrayChildren.current.length) {
            var isOpenArr = new Array(react_1.default.Children.count(children)).fill(false);
            setIsOpen(isOpenArr);
            if (bodyRef === null || bodyRef === void 0 ? void 0 : bodyRef.current) {
                arrayChildren.current = Array.from(bodyRef.current.children);
            }
        }
    }, [react_1.default.Children.count(children), bodyRef]);
    var handleToggleClick = function (idx) { return function (bool) {
        setIsOpen(function (prevState) {
            var newState = __spreadArray([], __read(prevState));
            newState[idx] = bool || !prevState[idx];
            return newState;
        });
    }; };
    var handleMouseOver = function (e) {
        if ((bodyRef === null || bodyRef === void 0 ? void 0 : bodyRef.current) &&
            e.target !== bodyRef.current &&
            !window.escapedSidebarPopover) {
            var idx_1 = arrayChildren.current.findIndex(function (child) {
                return child.contains(e.target);
            });
            setIsOpen(function (prevState) {
                var newState = new Array(prevState.length).fill(false);
                if (idx_1 !== -1) {
                    if (arrayChildren.current[idx_1].classList.contains("sidebar--popover-container")) {
                        idx_1 -= 1;
                    }
                    newState[Math.floor((numberOfDividers + idx_1) / 2)] = true;
                }
                return newState;
            });
        }
        else {
            window.escapedSidebarPopover = undefined;
            setIsOpen(new Array(arrayChildren.current.length).fill(false));
        }
    };
    var handleMouseLeave = function (e) {
        if ((bodyRef === null || bodyRef === void 0 ? void 0 : bodyRef.current) && e.target !== bodyRef.current) {
            var idx = arrayChildren.current.findIndex(function (child) {
                return child.contains(e.target);
            });
            if (idx !== -1 &&
                (!expanded ||
                    !arrayChildren.current[idx].classList.contains("sidebar--toggle-button"))) {
                setIsOpen(new Array(arrayChildren.current.length).fill(false));
            }
        }
    };
    var handleKeyDown = function (e) {
        if (e.key === "Escape" ||
            e.key === "Esc" ||
            (!e.target.classList.contains("sidebar--popover-button") &&
                (e.key === "ArrowDown" || e.key === "ArrowUp")) ||
            !e.target.nextElementSibling) {
            setIsOpen(function (prevState) {
                return new Array(prevState.length).fill(false);
            });
        }
    };
    return (react_1.default.createElement(exports.StyledSidebarBody, __assign({}, props, { className: style_utils_1.classNames("sidebar--body", className), onFocus: !expanded ? handleMouseOver : undefined, onKeyDown: !expanded ? handleKeyDown : undefined, onMouseLeave: !expanded ? handleMouseLeave : undefined, onMouseOver: !expanded ? handleMouseOver : undefined, ref: bodyRef }), react_1.default.Children.map(children, function (child, idx) {
        if (react_1.default.isValidElement(child) &&
            child.type.displayName === "SidebarButton") {
            var newProps = {
                isOpen: !expanded ? isOpen[idx] : undefined
            };
            if (child.props.type === "toggle") {
                newProps.onToggleClick = handleToggleClick(idx);
            }
            return react_1.default.cloneElement(child, newProps);
        }
        return child;
    })));
};
exports.default = SidebarBody;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map